<template>
  <div id="app">
    <Player />
  </div>
</template>

<script>
import Player from "./components/Player.vue";

export default {
  name: "App",
  components: {
    Player,
  },
};
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
}
</style>
